import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { useNotification } from '@/context/notification';
import { useResetDependentPassword } from '@/data/collaborators/dependents';
import type { Dependent } from '@/data/collaborators/dependents/interfaces';

interface ResetDependentPasswordDialogProps {
  dependent: Dependent;
  onClose: () => void;
}

export const ResetDependentPasswordDialog = ({
  dependent,
  onClose,
}: ResetDependentPasswordDialogProps) => {
  const { toast } = useNotification();
  const { mutate: resetDependentPassword, isPending } =
    useResetDependentPassword();
  const handlePasswordReset = () => {
    resetDependentPassword(dependent.id, {
      onSuccess: () => {
        toast({
          content: `Reenviamos um novo convite para: '${dependent.user.email}', com os dados de acesso à plataforma.`,
          title: 'Senha redefinida',
          type: 'success',
        });
        onClose();
      },
      onError: () => {
        toast({
          content: 'Erro ao redefinir senha.',
          title: 'Erro',
          type: 'error',
        });
      },
    });
  };

  return (
    <BaseDialog
      onClose={onClose}
      open
      title="Redefinir senha"
      actionsComponent={
        <>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            loading={isPending}
            onClick={handlePasswordReset}
            variant="contained"
          >
            Redefinir senha
          </Button>
        </>
      }
    >
      <Stack spacing={2}>
        <Typography gutterBottom>
          Seu dependente ainda não se cadastrou na Galena ou precisa de uma nova
          senha?
        </Typography>
        <Typography>
          Enviaremos um novo convite para:{' '}
          <strong>'{dependent.user.email}'</strong>, com os dados de acesso à
          plataforma.
        </Typography>
      </Stack>
    </BaseDialog>
  );
};
